export default function pluralize(
    count: number,
    singular: string,
    plural: string = singular + "s",
    omitCount: boolean = false,
): string {
    if (omitCount) {
        return count === 1 ? singular : plural;
    }
    return count === 1 ? `${count} ${singular}` : `${count} ${plural}`;
}
